import { ReactNode } from "react";
import { createFastContext } from "../createFastContext2";

interface IState {
    search?: string
}

const {
    Provider,
    useStore: useFilter,
    setStore: setFilter,
    getStore: getFilter,
    callEvent: callEventFilter
} = createFastContext<IState>({

});

const FilterProvider = ({ children, ...args }: { children: ReactNode } & Partial<IState>) => {
    return <Provider props={{ ...args }}>
        {children}
    </Provider>
}

export { callEventFilter, FilterProvider, getFilter, setFilter, useFilter };

